import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import SystemCohortPanelFull from '../containers/SystemCohortPanelFull';
import SystemCohortPanelNarrow from '../containers/SystemCohortPanelNarrow';

const SystemCohortPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: SystemCohortPanelFull, narrow: SystemCohortPanelNarrow }}
    onChange={onChange}
  />
);

export default SystemCohortPanel;
